import React, { Component } from "react";

import axios from "../../../axios-order";
import SimpleReactValidator from "simple-react-validator";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

class DegreeAttestation extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator();
  }
  state = {
    attestation: {
      name: "",
      email: "",
      university: "",
      contact_no: "",
      documents: [],
    },
    dataFile: [],
    error: false,
  };
  handleUserInput = (e) => {
    this.state.dataFile = []
    if (e.target.type === "file") {
      this.fileHandler(e.target.files);
    } else {
      const value = e.target.value;
      this.setState({
        ...this.state,
        attestation: {
          ...this.state.attestation,
          [e.target.name]: value,
        },
      });
    }
  };
  fileHandler = (files) => {
    let filesData1 = [];
    let data = [];
    let filesForm = files;
    for (let k of Object.keys(filesForm)) {
      filesData1.push(filesForm[k]);
      this.setState((prevState) => {
        return {
          dataFile: prevState.dataFile.push(filesForm[k]),
        };
      });
    }
    console.log( filesData1);
    filesData1.forEach((file) => {
      this.getBase64(file).then((response) => {
        data.push(response);
      });
    });
    this.setState({
      ...this.state,
      attestation: {
        ...this.state.attestation,
        documents: data,
      },
    });
  };
  getBase64 = (file) => {
    return new Promise((resolve) => {
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        resolve(reader.result);
      };
    });
  };
  submitForm = (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      console.log(this.state.attestation);
      this.props.onSetLoader();
      axios
        .post("degree-attestation", this.state.attestation)
        .then((response) => {
          console.log(response);
          if (response.status === 200) {
            this.props.onSetLoader();
            this.props.history.replace("/");
          }
        })
        .catch((error) => {
          console.log(error);
          this.props.onSetLoader();
        });
      return true;
    } else {
      if (this.state.attestation.documents.length === 0) {
        this.setState({
          error: true,
        });
      } else {
        this.setState({
          error: false,
        });
      }
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  };
  render() {
    return (
      <div>
        <div className="banner-image country">
          <div className="mx-width">
            <div className="banner-text">
              <h1 className="bg-text1 mb-1">
                <span className="text-color2">Degree Attestation</span>
              </h1>
            </div>
          </div>
        </div>
        <div className="my-3">
          <h2 className="text-color1 text-center heading2 mb-0">
            Fill the Form
          </h2>
        </div>
        <div className="form-section">
          <div className="ms-width">
            <form action="" method="post">
              <div className="form-container mb-4">
                <h4 className="heading4 text-color2 mb-3 pl-3">
                  Degree Details
                </h4>
                <div className="form-wrap mc-border">
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="name" className="form-label1">
                          Name
                        </label>
                        <input
                          id="name"
                          className="form-control form-input1"
                          name="name"
                          placeholder="Name"
                          value={this.state.attestation.name}
                          onChange={this.handleUserInput}
                        />
                        {this.validator.message(
                          "name",
                          this.state.attestation.name,
                          "required|alpha_space",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="contact_no" className="form-label1">
                          Phone
                        </label>
                        <input
                          id="contact_no"
                          className="form-control form-input1"
                          type="phone"
                          name="contact_no"
                          placeholder="Phone"
                          onChange={this.handleUserInput}
                          value={this.state.attestation.contact_no}
                        />
                        {this.validator.message(
                          "phone",
                          this.state.attestation.contact_no,
                          "required|phone",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="f-row">
                    <div className="fr-left">
                      <div className="form-group">
                        <label htmlFor="email" className="form-label1">
                          Email
                        </label>
                        <input
                          id="email"
                          name="email"
                          className="form-control form-input1"
                          type="email"
                          placeholder="Email"
                          onChange={this.handleUserInput}
                          value={this.state.attestation.email}
                        />
                        {this.validator.message(
                          "email",
                          this.state.attestation.email,
                          "required|email",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                    <div className="fr-right">
                      <div className="form-group">
                        <label htmlFor="university" className="form-label1">
                          University
                        </label>
                        <input
                          id="university"
                          name="university"
                          className="form-control form-input1"
                          type="text"
                          placeholder="University"
                          onChange={this.handleUserInput}
                          value={this.state.attestation.university}
                        />
                        {this.validator.message(
                          "university",
                          this.state.attestation.university,
                          "required|alpha_space",
                          { className: "text-danger" }
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="form-group mb-0 text-center">
                    <input
                      type="file"
                      single="true"
                      hidden
                      name="document"
                      id="files"
                      onChange={this.handleUserInput}
                    />
                    <label
                      htmlFor="files"
                      type="button"
                      className="btn btn-docs mr-2"
                    >
                      Upload Docs
                    </label>
                    <span>
                      {this.state.dataFile.map((file, index) => {
                        return <span key={index}>{file.name}</span>;
                      })}
                    </span>
                    <div className="text-danger">
                      {this.state.error === true ? "Upload a file" : null}
                    </div>
                  </div>
               
                </div>
                <div className="form-group text-right mt-4">
                  <button
                    type="button"
                    className="btn btn-apply"
                    onClick={this.submitForm}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetLoader: () => dispatch({ type: "SET_LOADER" }),
  };
};

export default connect(null, mapDispatchToProps)(withRouter(DegreeAttestation));
